import { render, staticRenderFns } from "./NuCafeUg.vue?vue&type=template&id=6a4d145f&"
import script from "./NuCafeUg.vue?vue&type=script&lang=js&"
export * from "./NuCafeUg.vue?vue&type=script&lang=js&"
import style0 from "./NuCafeUg.vue?vue&type=style&index=0&id=6a4d145f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports